import React from "react";
import "./Checkbox.css";
import Checkbox from "./Checkbox";

const RoundedCheckbox = ({ className = "", ...props }) => {
  return <Checkbox {...props} className={`${className} rounded-checkbox`} />;
};

export default RoundedCheckbox;
